/* ==========================================================================
   Scroll Prevention Utility - Asian American Forward Website
   ========================================================================== */

let scrollPosition = 0;
let isScrollDisabled = false;

/* ==========================================================================
   Scroll Prevention Functions
   ========================================================================== */

function preventDefault(e) {
  e.preventDefault();
}

function preventDefaultForScrollKeys(e) {
  const keys = { 37: 1, 38: 1, 39: 1, 40: 1, 32: 1, 33: 1, 34: 1, 35: 1, 36: 1 };
  if (keys[e.keyCode]) {
    preventDefault(e);
    return false;
  }
}

function disableScroll() {
  if (isScrollDisabled) return; // Already disabled
  
  console.log('🔒 Disabling scroll');
  
  // Store current scroll position
  scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
  
  // Add CSS class for overflow hidden
  document.body.classList.add('modal-open');
  
  // Prevent scroll events
  window.addEventListener('wheel', preventDefault, { passive: false });
  window.addEventListener('touchmove', preventDefault, { passive: false });
  window.addEventListener('keydown', preventDefaultForScrollKeys, false);
  
  // Prevent arrow key scrolling
  document.addEventListener('keydown', preventDefaultForScrollKeys, false);
  
  isScrollDisabled = true;
}

function enableScroll() {
  if (!isScrollDisabled) return; // Already enabled
  
  console.log('🔓 Enabling scroll');
  
  // Remove CSS class
  document.body.classList.remove('modal-open');
  
  // Remove event listeners
  window.removeEventListener('wheel', preventDefault, { passive: false });
  window.removeEventListener('touchmove', preventDefault, { passive: false });
  window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
  document.removeEventListener('keydown', preventDefaultForScrollKeys, false);
  
  isScrollDisabled = false;
}

/* ==========================================================================
   Public API
   ========================================================================== */

export function preventModalScroll() {
  disableScroll();
}

export function allowModalScroll() {
  enableScroll();
}

export function isScrollPrevented() {
  return isScrollDisabled;
}

console.log('✅ Scroll prevention utility loaded'); 